import { RootState } from '@domain/root-reducer'
import React, { FC } from 'react'
import { Helmet } from 'react-helmet-async'
import { useSelector } from 'react-redux'

const Consent: FC = () => {

    const consent = useSelector((state: RootState) => state.cookieConsent)

    const writeKeyGA = process.env.REACT_APP_GA_API_KEY
    if (writeKeyGA) {
        return (
            <Helmet>
                <script>
                    {`window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments);}
                    gtag('consent', 'default', {
                    'ad_storage': 'denied',
                    'ad_user_data': 'denied',
                    'ad_personalization': 'denied',
                    'analytics_storage': 'denied'
                    });`}
                </script>
                <script
                    src={`https://www.googletagmanager.com/gtag/js?id=${writeKeyGA}`}
                    async
                ></script>
                <script>
                    {`window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                window.gtag = gtag;
                gtag('js', new Date());
                gtag('set', {'cookie_flags': 'Secure'});
                gtag('config', '${writeKeyGA}');`}
                </script>
                {consent && consent.ga && (
                    <script>
                        {`gtag('consent', 'update', {
                  'ad_user_data': 'granted',
                  'ad_storage': 'granted',
                  'analytics_storage': 'granted'
              })`}
                    </script>
                )}
            </Helmet>
        )
    }
    return null
}
export default Consent